import { ISearchSuggestionHoverXP } from '@faire/web-api--source/indigofair/data/ISearchSuggestionHoverXP';
import { SettingConst } from '@faire/web-api--source/types';

/**
 * Controls preloading of search results on logged-in search page suggestion hover to improve response time
 */
export const LISP_SUGGESTION_HOVER_SPECULATION_RELAUNCH_250130 =
  'LISP_SUGGESTION_HOVER_SPECULATION_RELAUNCH_250130' as SettingConst<
    'LISP_SUGGESTION_HOVER_SPECULATION_RELAUNCH_250130',
    keyof typeof ISearchSuggestionHoverXP.Bucket,
    'RETAILER' | 'VISITOR_WEB'
  >;
